const DataKerjasama = [
    {
        id: 1,
        judul: "Nads",
        src: "img/clients/nadsvg.svg",
        alt: "Logo Nads",
        deskripsi: "Membuat web portfolio",
        link: "https://nadazkia.github.io",
    },
    {
        id: 2,
        judul: "Dapoer Nenek",
        src: "img/clients/dapoernenekpng.png",
        alt: "Logo Dapoer Nenek",
        deskripsi: "Membuat logo Dapoer Nenek",
        link: "#",
    }
]

export default DataKerjasama